import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=90c05150&scoped=true&"
import script from "./ActionButton.vue?vue&type=script&lang=js&"
export * from "./ActionButton.vue?vue&type=script&lang=js&"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=90c05150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c05150",
  null
  
)

export default component.exports